import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../img/logo-softmining.svg';
import Header from '../components/header';
import { enqueueScrapeRequest, checkScrapeStatus, getScrapeOutput } from '../Utility/ExtractEdge/extractEdgeUtils';
import { retrieveMineData } from '../Utility/ConsumeToken/consumeToken';
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { navigateToNextPage } from "../Utility/CreatePipeline/createPipelineUtils";

const ExtractEdge = () => {
    const [gid, setGid] = useState('');
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [scrapeOutput, setScrapeOutput] = useState(null);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        setShowModal(true);
        setStatusMessage("Sending scraping request...");
        setScrapeOutput(null);
        setDownloadUrl(null);

        try {
            const apitoken = await retrieveMineData();
            // 1. Send the scraping request
            const enqueueResult = await enqueueScrapeRequest(apitoken._id, gid, name);
            console.log("Enqueue result:", enqueueResult);
            setStatusMessage("Request queued. Checking status...");

            // 2. Poll for request status
            let completed = false;
            while (!completed) {
                // Wait 3 seconds between polls
                await new Promise(resolve => setTimeout(resolve, 3000));
                const statusResult = await checkScrapeStatus(apitoken._id, gid);
                console.log("Status result:", statusResult);
                // Check that the status is "REQUEST COMPLETED" as specified
                if (statusResult.output === "REQUEST COMPLETED") {
                    setStatusMessage("Scraping completed. Retrieving output...");
                    completed = true;
                } else {
                    setStatusMessage(`Current status: ${statusResult.output}`);
                }
            }

            // 3. Retrieve the scraping output (graph)
            const rawOutput = await getScrapeOutput(apitoken._id, gid);
            let formattedOutput = null;
            if (rawOutput && rawOutput.output) {
                try {
                    formattedOutput = JSON.parse(rawOutput.output);
                } catch (parseError) {
                    console.error("Error parsing output:", parseError);
                    // In case of parsing error, you may decide to use the raw string or throw an error.
                }
            }
            setScrapeOutput(formattedOutput);

            // Create a downloadable JSON file with formatted output
            const blob = new Blob([JSON.stringify(formattedOutput, null, 2)], { type: "application/json" });
            const url = URL.createObjectURL(blob);
            setDownloadUrl(url);

            setStatusMessage("Scraping output retrieved.");
        } catch (err) {
            console.error(err);
            setError(err.message);
            setStatusMessage("");
        } finally {
            setLoading(false);
        }
    };

    // Function to proceed with the pipeline using the common variable "pipelineData"
    const proceedPipeline = () => {
        if (!location.state) return;
        const { params = {}, board = [], nextPageIndex = 0 } = location.state;

        // unisci l�output di questo step ai params che passano allo step successivo
        const newParams = { ...params, pipelineData: scrapeOutput };

        // aggiorna currentIndex nel drawer + naviga
        navigateToNextPage(nextPageIndex, newParams, board, navigate);
    };


    return (
        <>
            <Header />
            <div className="form-container-innerpage">
                <div className="riga">
                    <h3 className="titolo titoloFeature">ExtractEdge</h3>
                    <p className="text DescriptionFeature">
                        ExtractEdge is an advanced tool for mining and analyzing relationships between millions of scientific papers. It processes semantic graphs obtained from new-road.eu/platform/ to extract meaningful insights, helping researchers navigate vast literature efficiently. ExtractEdge enhances discovery by identifying trends, correlations, and knowledge gaps across diverse scientific domains.
                    </p>
                </div>
                <div className="form formLogin">
                    <img src={logo} className="sign-logo" alt="logo" />
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="gid">Project Name:</label>
                        <input
                            placeholder="Enter only letters and numbers..."
                            type="text"
                            id="name"
                            name="name"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            pattern="[A-Za-z0-9]{5,}"
                            title="Only letters and numbers (no space or special characters), at least 5 characters."
                            minLength={5}
                            required
                        />
                        <label htmlFor="gid">GID:</label>
                        <input
                            placeholder="Enter GID..."
                            type="text"
                            id="gid"
                            name="gid"
                            value={gid}
                            onChange={(e) => setGid(e.target.value)}
                            required
                        />
                        <div className="space10"></div>
                        <button className="sign-button button" type="submit" disabled={loading}>
                            {loading ? "Processing..." : "Start ExtractEdge"}
                        </button>
                    </form>

                    <div className="riga">
                        <Link className="textlink textLinkSign" to="/dashboard">Back to Dashboard <FaArrowRight size={12} style={{ marginLeft: '8px', marginBottom: '-1px' }} /></Link>
                    </div>
                    {error && <p style={{ color: "red" }}>Error: {error}</p>}
                </div>
            </div>

            {showModal && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <div className="divCloseButton">
                            <button onClick={() => setShowModal(false)} className="CloseButton text">
                                X
                            </button>
                        </div>
                        <h4 className="popupTitle titolo">ExtractEdge Process</h4>
                        <p>{statusMessage}</p>
                        {loading && (
                            <>
                                <p>Please wait, the process is running...</p>
                                <p>
                                    You can close this popup and navigate to another screen, as the process will continue to run in the background.
                                </p>
                                <button className="sign-button button" onClick={() => navigate('/ProcessStatusPage')}>
                                    Verify Process Status
                                </button>
                            </>
                        )}
                        {!loading && downloadUrl && (
                            <>
                                <p>Process completed!<br></br>The resulting files have been saved on the ExtractEdge Storage page.</p>
                                {location.state && location.state.nextPageIndex !== undefined ? (
                                    <>
                                    <button className="sign-button button" onClick={proceedPipeline}>
                                        Proceed to next feature
                                    </button>
                                        <button className="sign-button button" onClick={() => navigate('/ExtractEdgeStorage')}>
                                        Go to ExtractEdge Storage
                                    </button>
                                    </>
                                ) : (
                                    <>
                                    <a href={downloadUrl} download="scrapeOutput.json" className="sign-button button">
                                        Download JSON
                                    </a>
                                    <button className="sign-button button" onClick={() => navigate('/ExtractEdgeStorage')}>
                                        Go to ExtractEdgeStorage
                                    </button>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ExtractEdge;
